/* import __COLOCATED_TEMPLATE__ from './n-plus-one-authorization.hbs'; */
var _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { assertInstanceOf } from '@banking/ui/utils/assert';
import { StateType } from '@banking/ui/workflows/balance';
let _class = (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "AuthState", StateType.AuthState);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get errorMessage() {
    switch (this.args.authState ?? StateType.AuthState.NONE) {
      case StateType.AuthState.SUCCESS:
      case StateType.AuthState.NONE:
        return undefined;
      case StateType.AuthState.ERROR:
        return this.intl.t('banking.components.common.nPlusOneAuthorization.errorMessage.error');
      case StateType.AuthState.EXPIRED:
        return this.intl.t('banking.components.common.nPlusOneAuthorization.errorMessage.expired');
      case StateType.AuthState.REJECTED:
        return this.intl.t('banking.components.common.nPlusOneAuthorization.errorMessage.rejected');
    }
  }
  get invalid() {
    switch (this.args.authState ?? StateType.AuthState.NONE) {
      case StateType.AuthState.SUCCESS:
      case StateType.AuthState.NONE:
        return false;
      case StateType.AuthState.ERROR:
      case StateType.AuthState.EXPIRED:
      case StateType.AuthState.REJECTED:
        return true;
    }
  }
  get isResendButtonHidden() {
    return !this.args.isResendButtonActive;
  }
  marketCodeInputValueChange(event) {
    const code = assertInstanceOf(event, CustomEvent).detail.code;
    this.args.onValueChange?.(code);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "marketCodeInputValueChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "marketCodeInputValueChange"), _class2.prototype), _class2);
export { _class as default };